import React, {useEffect, useState } from 'react'
import { UserAuth } from "./context/AuthContext";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase/config";
import { getDocs, collection, query, where } from 'firebase/firestore';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import logo from "./logo-no-background.png"
export default function Admin() {
    let {  logout } = UserAuth();
     let [startDate, setStartDate] = useState(new Date());
     let [endDate, setEndDate] = useState(new Date());
     let [scoresData, setScoresData] = useState();
     let navigate = useNavigate();
     let handleLogout = () => {
        logout();
        navigate("/");
      };
      const handleExport = () => {
        let start = new Date(startDate);
        let end = new Date(endDate);
        const usersCollectionRef = query(collection(db, "users"), where("scoreDate", ">", start),where('scoreDate', '<', end));
        getDocs(usersCollectionRef).then(querySnapshot => {
            let data = querySnapshot.docs.map(doc => doc.data());
            let refinedData = data.map(obj => ({email:obj.email, languageOption:obj.languageOption, name:obj.name, school:obj.school, schoolEmail:obj.schoolEmail,scoreDate:obj.scoreDate.toDate(), scores:obj.scores[0], level:obj.level, heritageLearner:obj.heritageLearner,classRecommended:obj.classRecommended}));
            setScoresData(data);
            console.log(refinedData)
            const fileType ="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";

            const ws = XLSX.utils.json_to_sheet(refinedData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const excelldata = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(excelldata, 'users-scores' + fileExtension);
        })
        .catch(error => {
            console.error(error);
        });
      }
  return (
    <div className="wrapper position-relative">
        <div className="header">
            <a className="logo" href={void(0)}>
              Adaptive Chinese Placement Test
            </a>
          <div className="right-content">
            <a href="#" onClick={() => navigate("/Admin")}>Export-Results</a>
            <a href="#" onClick={() => navigate("/userActivity")}>User-Activity</a>
            <a href="#" onClick={() => handleLogout()}>Logout</a>
          </div>
        </div>
          <div className="container">
              <div className="multisteps_form position-relative overflow-hidden" id="wizard">
                <div className="row">
                    <div className="col-md-12">
                      <div className="form_header_content text-center pt-4">
                          <h2>Export Results to Excell</h2>
                          <p>Select Date Range</p>
                          <div className="auth-form">
                          <input
                          className="my-input"
                            type="date"
                            value={startDate}
                            onChange={(event) => setStartDate(event.target.value)}
                            placeholder="Start Date"
                          />
                          <input
                          className="my-input"
                            type="date"
                            value={endDate}
                            onChange={(event) => setEndDate(event.target.value)}
                            placeholder="End Date"
                          />
                          <button
                        className="theme-btn" onClick={() => handleExport()}>
                          Export To Excell
                        </button>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
          </div>
        </div>
  )
}
